import React from 'react';
import './Contributions.css';

// ADDED imports for your new local icon components
import GithubIcon from './icons/GithubIcon';
import LeetcodeIcon from './icons/LeetCodeIcon';

// The 'contributions' array now uses your new local components
const contributions = [
  {
    title: "GitHub Profile",
    platform: "GitHub",
    icon: <GithubIcon />,
    link: "https://github.com/Karan2916", // <-- REPLACE WITH YOUR GITHUB URL
    description: "Check out my projects, code, and contributions.",
  },
  {
    title: "LeetCode Profile",
    platform: "LeetCode",
    icon: <LeetcodeIcon />,
    link: "https://leetcode.com/u/8722645712/", // <-- REPLACE WITH YOUR LEETCODE URL
    description: "View my problem-solving progress and contest ratings.",
  },
];

const Contributions: React.FC = () => {
  return (
    <div className="contributions-container">
      <h2 className="contributions-title">💻 My Coding Profiles</h2>
      <p className="contributions-intro">Check out my projects on GitHub and my problem-solving skills on LeetCode.</p>
      <div className="contributions-grid">
        {contributions.map((item, index) => (
          <a href={item.link} key={index} target="_blank" rel="noopener noreferrer" className="contribution-card" style={{ '--delay': `${index * 0.15}s` } as React.CSSProperties}>
            <div className="contribution-icon animated-icon">{item.icon}</div>
            <div className="contribution-info">
              <h3 className="contribution-title">{item.title}</h3>
              <p className="contribution-description">{item.description}</p>
              <span className="contribution-platform">{item.platform}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Contributions;